/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./subscription-material-push.vue?vue&type=template&id=6b505585&scoped=true&"
import script from "./subscription-material-push.vue?vue&type=script&lang=js&"
export * from "./subscription-material-push.vue?vue&type=script&lang=js&"
import style0 from "./subscription-material-push.vue?vue&type=style&index=0&id=6b505585&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b505585",
  null
  
)

export default component.exports